const exportData = {
    main: "/",
    login: "/login",
    Register: "/Register",
    Login_pw_help: "/Forgot-password",
    Support: "/Support",
    Inquiry: "/Inquiry",
    Price: "/Price",
    Profile: "/Profile",
    ProfileEdit: "/ProfileEdit",
    ProfileCoupon: "/ProfileCoupon",
    BuyList: "/BuyList",
    CancelSub: "/CancelSub",
    PayList: "/PayList",
    CardList: "/CardList",
    InquiryList: "/InquiryList",
    PlusMember: "/PlusMember",
    PlusAdmin: "/PlusAdmin",
    Education: "/School",
    Modeling: "/features/SketchUpStyleModeling",
    PModeling: "/features/PolygonModeling",
    UV_Editing: "/features/UVEditing",
    Painting: "/features/Painting",
    Rigging: "/features/RiggingAndSkinning",
    Intergration: "/features/Intergration",
    Extension: "/Extension",
    AI: "/features/Gen-AI",
    Library: "/features/Template",
    GameDev: "/solution/GameDev",
    Metaverse: "/solution/Metaverse",
    Indust: "/Indust",
    Edu: "/solution/Education",
    Licensing: "/Licensing",
    PlusGroup: "/PlusGroup",
    Term: "/Term"
}

export default exportData;